import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsMuteAllTitle = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-mute-all-title", { ref: ref }, children));
};
export default VeltNotificationsPanelSettingsMuteAllTitle;
